import { BrowserRouter } from "react-router-dom";
import { Routering } from "./routes";
import { MenuLateral, Inicio } from "./shered/components";
import { AppThemeProvider } from "./shered/contexts/ThemeContext";
import { AuthProvider, DrawerProvider } from "./shered/contexts";
import { Enviroment } from './shered/enviroments';

import "./shered/forms/TraducoesYup";
import Maintenance from "./shered/components/manuntencao/Manuntencao";

export const App = () => {

  if (Enviroment.MANUNTENCAO) {
    return (
      <Maintenance 
        estimatedTime=" Junho de 2026"
      />
    );
  }
  return (
    <AuthProvider>
      <AppThemeProvider>
        <BrowserRouter>
          <Inicio visivel={false}>
            <DrawerProvider>
              <MenuLateral >
                <Routering />
              </MenuLateral>
            </DrawerProvider>
          </Inicio>
        </BrowserRouter>
      </AppThemeProvider>
    </AuthProvider>

  );
}


